import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import App from "./App";
import { AuthProvider } from "@/features/auth/auth-context";
import { I18nProvider } from "@/i18n";
import "@/styles/globals.css";

const queryClient = new QueryClient({ defaultOptions: { queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false }, mutations: { retry: 0 } } });

ReactDOM.createRoot(document.getElementById("root")!).render(<React.StrictMode><BrowserRouter><QueryClientProvider client={queryClient}><I18nProvider><AuthProvider><App /><Toaster richColors position="top-right" /></AuthProvider></I18nProvider></QueryClientProvider></BrowserRouter></React.StrictMode>);
